<template>
  <div class="conversation-list-item" v-if="message" @click="handleClick">
    <div class="d-flex align-center flex-wrap">
      <div class="circle-active" :class="{ hidden: !conversation.isOpen }" />
      <div class="avatar-initials mr-3" v-if="showParticipants">
        <span> {{ userInitials }} </span>
      </div>
      <v-icon class="interview-icon" large v-else>
        mdi-comment-text-multiple-outline
      </v-icon>
      <div class="d-flex flex-column">
        <h3 class="mb-0">
          {{ conversation.subject | textLimit }}
        </h3>
        <div>
          <div v-if="showParticipants">
            {{ sender | fullName }}
            <v-icon> mdi-arrow-right </v-icon>
            {{ conversation.recipientName }}
          </div>
          <span class="message-body">
            {{ messageBody | textLimit }}
          </span>
          <RelatedToLink
            v-if="showRelatedToLink"
            preventSelecting
            :entityType="conversation.relatedToType"
            :text="relatedToDescription"
            :id="conversation.relatedToId"
          />
        </div>
      </div>
    </div>
    <span class="message-date">
      {{ message.sentDate | timeForHumans }}
    </span>
  </div>
</template>

<script>
import { getNameInitials } from "@/utils/helpers";
import { get, size, take, join } from "lodash";
import { getTimeForHumans } from "@/utils/helpers";
import { getRelatedToDescriptionFullDescription } from "@/utils/conversations";
import { convertHtmlToText } from "@/views/conversations/modules/utils";
import RelatedToLink from "@/views/conversations/ConversationDetails/components/RelatedToLink";

export default {
  props: {
    conversation: {
      type: Object,
      required: true
    },
    showParticipants: Boolean
  },
  components: {
    RelatedToLink
  },
  computed: {
    message() {
      return this.conversation.lastMessage;
    },
    messageBody() {
      const { body } = this.message;
      return this.isEmailFormat ? convertHtmlToText(body) : body;
    },
    participant() {
      return get(this.conversation, "recipient");
    },
    userInitials() {
      return getNameInitials(this.participant);
    },
    isEmailFormat() {
      return this.conversation.conversationFormat === "email";
    },
    relatedToDescription() {
      return getRelatedToDescriptionFullDescription(this.conversation);
    },
    showRelatedToLink() {
      return this.conversation.relatedToType && this.conversation.relatedToId;
    },
    sender() {
      return get(this.message, "sender");
    }
  },
  methods: {
    handleClick() {
      this.$router.push(`/conversations/${this.conversation.id}`);
    }
  },
  filters: {
    timeForHumans(date) {
      return getTimeForHumans(date);
    },
    textLimit(text) {
      return size(text) > 50 ? `${join(take(text, 50), "").trim()}...` : text;
    }
  }
};
</script>

<style lang="scss">
.conversation-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 15px 5px;

  &:hover {
    background-color: $background !important;
  }
  .message-date {
    color: $secondary-text;
    margin-left: 20px;
    display: flex;
    min-width: fit-content;
  }
  .message-body {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 22px;
    max-height: 44px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .circle-active {
    margin-right: 10px;
    background-color: $primary;
    width: 12px;
    min-width: 12px;
    height: 12px;
    border-radius: 50%;

    &.hidden {
      visibility: hidden;
    }
  }

  @media only screen and (max-width: $mobile-breakpoint - 1) {
    flex-direction: column;
    align-items: flex-start;

    .message-date {
      margin: 10px 0 0 0;
      align-self: flex-end;
    }
  }
}
</style>
